import BiddingTable from './BiddingTable';

export default BiddingTable;
